import Http from "./Http";

export class PostsService extends Http {
  /**
   * Create new post
   * @param {Object} body
   * @param {string} body.title
   * @param {string} body.description
   * @param {number} body.type 1 - device, 2 - socialNetwork, 3 - challenge
   * @param {number} body.contentType 1 - text, 2 - image, 3 - video, 4 - audio
   * @param {number} body.accessType 1 - freeEveryone, 2 - freeFollowers, 3 - paid
   * @param {number} body.priceType 1 - usd, 2 - matic
   * @param {number} body.socialType 1 - instagram 2 - youtube 3 - twitter 4 - facebook 5 - twitch todo: check API
   * @param {string} body.price decimal MATIC or USD price
   * @param {Array.<number>} body.subscriptionIds ids of selected subscriptions
   * @param {string} body.scheduledDate scheduled date and time (optional)
   */
  createPost(body) {
    return this.post("/posts", body);
  }

  /**
   * Get list of posts by username
   * @param {string} username
   * @param {Object} params
   * @param {number} params.limit
   * @param {number} params.cursor
   * @param {number} params.direction 1 - NEXT, 2 - PREVIOUS
   */
  getPostsByUsername(username, params) {
    return this.get(`/posts/users/${username}`, { params });
  }

  /**
   * Get list of my scheduled posts
   * @param {Object} params
   * @param {number} params.limit
   * @param {number} params.offset
   */
  getMyScheduledPosts(params) {
    return this.get(`/posts/me/scheduled`, { params });
  }

  /**
   * Get post details
   * @param {string} uniqueKey
   */
  getPostByUniqueKey(uniqueKey) {
    return this.get(`/posts/${uniqueKey}`);
  }

  /**
   * Delete post
   * @param {number} id
   */
  deletePostById(id) {
    return this.delete(`/posts/${id}`);
  }

  /**
   * Pin/unpin post
   * @param {number} id
   */
  pinPost(id) {
    return this.patch(`/posts/${id}/is-pinned`);
  }

  /**
   * Get post position after pi or unpin
   * @param {number} id
   */
  getPinPostPosition(id) {
    return this.get(`/posts/${id}/pin-position`);
  }

  /**
   * Like post
   * @param {number} id
   */
  likePostById(id) {
    return this.post(`/posts/${id}/likes`);
  }

  /**
   * Remove your like from post
   * @param {number} id
   */
  unlikePostById(id) {
    return this.delete(`/posts/${id}/likes`);
  }

  /**
   * Add report to post
   * @param {number} id
   * @param {object} body
   * @param {number} body.type report type. 1 - spam, 2 - fake, 3 - violence, 5 - copyright, 6 - other
   */
  reportPostById(id, body) {
    return this.post(`/posts/${id}/reports`, body);
  }

  /**
   * Add comment to post
   * @param {number} id post id
   * @param {Object} body
   * @param {string} body.text text comments
   */
  createComment(id, body) {
    return this.post(`/posts/${id}/comments`, body);
  }

  /**
   * Get post's comments by post's unique key
   * @param {string} uniqueKey posts unique key
   * @param {Object} params
   * @param {number} params.limit
   * @param {number} params.cursor
   * @param {number} params.direction 1 - NEXT, 2 - PREVIOUS
   */
  getCommentsByUniqueKey(uniqueKey, params) {
    return this.get(`/posts/${uniqueKey}/comments`, { params });
  }

  /**
   * Get current user feed all posts
   * @param {Object} params
   * @param {number} params.limit
   * @param {number} params.cursor
   * @param {boolean} params.onlyPurchased
   * @param {number} params.direction 1 - NEXT, 2 - PREVIOUS
   */
  getFeedPosts(params) {
    return this.get(`/posts`, { params });
  }

  /**
   * Buy post
   * @param {number} postId
   * @param {object} body
   * @param {string} body.paymentMethod
   * @param {number} body.amount custom USD amount
   * @param {string} body.transactionHash for crypto only
   * @param {string?=} body.referral
   */
  purchasePost(postId, body) {
    return this.post(`/posts/${postId}/payments`, body);
  }

  /**
   * Get post's subscription list
   * @param {number} id post id
   * @param {object} params
   * @param {object} params.limit
   * @param {object} params.offset
   * @returns
   */
  getPostSubscriptions(id, params) {
    return this.get(`/posts/${id}/subscriptions`, { params });
  }

  /**
   * Update post
   * @param {number} id post id
   * @param {Object} body
   * @param {string} body.title
   * @param {string} body.price
   * @param {number} body.priceType 1 - usd, 2 - matic
   * @param {number} body.accessType 1 - freeEveryone, 2 - freeFollowers, 3 - paid
   * @param {string} body.description
   * @param {Array.<number>} body.subscriptionIds
   */
  editPost(id, body) {
    return this.put(`/posts/${id}`, body);
  }

  /**
   * Get post's likes list
   * @param {number} id post id
   * @param {object} params
   * @param {object} params.limit
   * @param {object} params.offset
   * @returns
   */
  getLikesList(id, params) {
    return this.get(`/posts/${id}/likes/users`, { params });
  }
}

export default new PostsService();
